import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

const OfflineBanner = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [visible, setVisible] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
      setVisible(true);
    };
    const handleOnline = () => {
      setIsOffline(false);
      // Keep visible briefly to show "back online" message, then slide out
      setTimeout(() => setVisible(false), 2000);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 px-4 py-2.5 flex items-center justify-center gap-2 shadow-lg text-white transition-all duration-500 ease-in-out ${
        isOffline
          ? 'bg-red-600 animate-[slideDown_0.4s_ease-out]'
          : 'bg-green-600 animate-[slideUp_0.5s_ease-in_1.5s_forwards]'
      }`}
      style={{
        animation: isOffline
          ? 'slideDown 0.4s ease-out'
          : 'slideDown 0.4s ease-out, slideUp 0.5s ease-in 1.5s forwards',
      }}
    >
      <style>{`
        @keyframes slideDown {
          from { transform: translateY(-100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes slideUp {
          from { transform: translateY(0); opacity: 1; }
          to { transform: translateY(-100%); opacity: 0; }
        }
      `}</style>
      {isOffline ? <WifiOff size={18} /> : <Wifi size={18} />}
      <span className="text-sm font-medium">
        {isOffline ? 'Nemáte připojení k internetu' : 'Připojení obnoveno'}
      </span>
    </div>
  );
};

export default OfflineBanner;
